import { useState } from "react";
import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import { ProfileDetailsContext } from "../../context/ProfileDetailsProvider";
import { adminAxios } from "../../axiosInstance";

export default function DownloadSalesCheckbox({ id }) {
  const [isChecked, setIsChecked] = useState(false);
  const { profileDetails } = React.useContext(ProfileDetailsContext);

  const requestType = "get";

  let downloadStatus = Number(profileDetails?.user?.company?.sales_download);

  React.useEffect(() => {
    setIsChecked(downloadStatus === 1);
  }, [downloadStatus]);

  // React.useEffect(() => {
  //   console.log(isChecked);
  // }, [isChecked]);

  const handleChange = async (event, id) => {
    setIsChecked((prevState) => !prevState);

    const actionStatus = event.target.checked ? "activate" : "deactivate";
    try {
      const response = await adminAxios[requestType](
        `orders/${actionStatus}/${id}`
      );

      // console.log(response);
    } catch (err) {
      // notify(err.message);
    }
  };
  return (
    <div>
      <div className="flex  items-center">
        <Checkbox
          checked={isChecked}
          onClick={(event) => handleChange(event, id)}
          inputProps={{ "aria-label": "controlled" }}
          sx={{ fontSize: "120px" }}
        />
        <h3>Enable Monthly Data Download for Analytics</h3>
      </div>

      <div className="text-sm text-gray-600 list-disc pl-5">
        <h4>
          <span className="text-green-500">
            <CheckIcon />
          </span>{" "}
          Your sales data will be automatically compiled at the end of each
          month for analytics.
        </h4>
        <h4>
          <span className="text-green-500">
            <CheckIcon />
          </span>{" "}
          You can disable this option at any time.
        </h4>
        <h4>
          <span className="text-green-500">
            <CheckIcon />
          </span>{" "}
          Data will be processed securely and used solely for reporting
          purposes.
        </h4>
      </div>
    </div>
  );
}
